export default __webpack_public_path__ + "static/media/icon_mobile_menu_my_data.f82d1142.svg";